/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IBilling {
    getPlaidCredentials(cancelToken?: CancelToken): AxiosPromise<PlaidCredentials>;
    billing(cancelToken?: CancelToken): AxiosPromise<BillingModel>;
    transactions(from: Date, to: Date, transactionType: AccountingTransactionType, page: number | undefined, cancelToken?: CancelToken): AxiosPromise<TransactionModel[]>;
    billingInvoices(startDate: Date, endDate: Date, page: number | undefined, cancelToken?: CancelToken): AxiosPromise<InvoiceRecordResult>;
    billingInvoiceDetails(id: string, cancelToken?: CancelToken): AxiosPromise<InvoiceDetails>;
    billingPayments(startDate: Date, endDate: Date, page: number | undefined, cancelToken?: CancelToken): AxiosPromise<PaymentRecordResult>;
    billingPaymentDetails(id: string, cancelToken?: CancelToken): AxiosPromise<PaymentDetails>;
    transactionsInfo(from: Date, to: Date, transactionType: AccountingTransactionType, cancelToken?: CancelToken): AxiosPromise<TransactionModelResult>;
    getBankLogo(institutionId: string, cancelToken?: CancelToken): AxiosPromise<string>;
    updateCard(cardInfo: BillingCardInfo, cancelToken?: CancelToken): AxiosPromise<CardModel>;
    addOrUpdateBankAccount(bankAccountInfo: PlaidBankAccountInfo, cancelToken?: CancelToken): AxiosPromise<BankAccountModel>;
    deleteBankAccount(plaidAccountId: string, cancelToken?: CancelToken): AxiosPromise<void>;
}

export const BASE_URL_TOKEN_Billing = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class Billing implements IBilling {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject(BASE_URL_TOKEN_Billing) @optional() private readonly baseUrl = "") {
    }

    getPlaidCredentials(cancelToken?: CancelToken): AxiosPromise<PlaidCredentials> {
        let url_ = "/app/api/settings/Billing/GetPlaidCredentials";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PlaidCredentials>(options_));
    }

    billing(cancelToken?: CancelToken): AxiosPromise<BillingModel> {
        let url_ = "/app/api/settings/Billing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BillingModel>(options_));
    }

    transactions(from: Date, to: Date, transactionType: AccountingTransactionType, page: number | undefined, cancelToken?: CancelToken): AxiosPromise<TransactionModel[]> {
        let url_ = "/app/api/settings/Billing/Transactions?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (transactionType === undefined || transactionType === null)
            throw new Error("The parameter 'transactionType' must be defined and cannot be null.");
        else
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<TransactionModel[]>(options_));
    }

    billingInvoices(startDate: Date, endDate: Date, page: number | undefined, cancelToken?: CancelToken): AxiosPromise<InvoiceRecordResult> {
        let url_ = "/app/api/settings/Billing/BillingInvoices?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + moment(startDate).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + moment(endDate).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<InvoiceRecordResult>(options_));
    }

    billingInvoiceDetails(id: string, cancelToken?: CancelToken): AxiosPromise<InvoiceDetails> {
        let url_ = "/app/api/settings/Billing/BillingInvoiceDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<InvoiceDetails>(options_));
    }

    billingPayments(startDate: Date, endDate: Date, page: number | undefined, cancelToken?: CancelToken): AxiosPromise<PaymentRecordResult> {
        let url_ = "/app/api/settings/Billing/BillingPayments?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + moment(startDate).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + moment(endDate).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PaymentRecordResult>(options_));
    }

    billingPaymentDetails(id: string, cancelToken?: CancelToken): AxiosPromise<PaymentDetails> {
        let url_ = "/app/api/settings/Billing/BillingPaymentDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<PaymentDetails>(options_));
    }

    transactionsInfo(from: Date, to: Date, transactionType: AccountingTransactionType, cancelToken?: CancelToken): AxiosPromise<TransactionModelResult> {
        let url_ = "/app/api/settings/Billing/TransactionsInfo?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + moment(from).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + moment(to).format("YYYY-MM-DDTHH:mm:ss") : "") + "&";
        if (transactionType === undefined || transactionType === null)
            throw new Error("The parameter 'transactionType' must be defined and cannot be null.");
        else
            url_ += "transactionType=" + encodeURIComponent("" + transactionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<TransactionModelResult>(options_));
    }

    getBankLogo(institutionId: string, cancelToken?: CancelToken): AxiosPromise<string> {
        let url_ = "/app/api/settings/Billing/GetBankLogo/{institutionId}";
        if (institutionId === undefined || institutionId === null)
            throw new Error("The parameter 'institutionId' must be defined.");
        url_ = url_.replace("{institutionId}", encodeURIComponent("" + institutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string>(options_));
    }

    updateCard(cardInfo: BillingCardInfo, cancelToken?: CancelToken): AxiosPromise<CardModel> {
        let url_ = "/app/api/settings/Billing/UpdateCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = cardInfo;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<CardModel>(options_));
    }

    addOrUpdateBankAccount(bankAccountInfo: PlaidBankAccountInfo, cancelToken?: CancelToken): AxiosPromise<BankAccountModel> {
        let url_ = "/app/api/settings/Billing/UpdateBankAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = bankAccountInfo;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<BankAccountModel>(options_));
    }

    deleteBankAccount(plaidAccountId: string, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/app/api/settings/Billing/DeleteBankAccount?";
        if (plaidAccountId === undefined || plaidAccountId === null)
            throw new Error("The parameter 'plaidAccountId' must be defined and cannot be null.");
        else
            url_ += "plaidAccountId=" + encodeURIComponent("" + plaidAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return makeCodedException(axios.request<void>(options_));
    }
}

export interface PlaidCredentials {
    PublicKey?: string | undefined;
    Environment: PlaidEnvironment;
    AuthWebhook?: string | undefined;
    PublicToken?: string | undefined;
    LegalName?: string | undefined;
    Email?: string | undefined;
}

export enum PlaidEnvironment {
    Sandbox = 0,
    Production = 1,
    Development = 2,
}

export interface BillingModel {
    Balance: number;
    ChargeOptions?: ChargeOptions | undefined;
    DaysBeforeSuspension?: number | undefined;
    IsSuspended: boolean;
    IsGracePeriod: boolean;
    Card?: CardModel | undefined;
    BankAccount?: BankAccountModel | undefined;
    ServiceOptions?: ServiceOptions | undefined;
    PaymentGatewayEnabled: boolean;
    TransactionsPageSize: number;
    BillToAccountId?: string | undefined;
}

export interface ChargeOptions {
    RechargeLimit: number;
    RechargeThreshold: number;
    SuspensionThreshold: number;
    GracePeriod: number;
}

export interface CardModel {
    Last4?: string | undefined;
    Name?: string | undefined;
    ExpMonth?: string | undefined;
    ExpYear?: string | undefined;
    Csv?: number | undefined;
    Type?: string | undefined;
}

export interface BankAccountModel {
    Last4?: string | undefined;
    BankName?: string | undefined;
    InstitutionId?: string | undefined;
    AccountId?: string | undefined;
    UnverifiedAccount?: boolean | undefined;
    IsAutoVerification?: boolean | undefined;
}

export interface ServiceOptions {
    EmployeeCount: number;
    TechnicianCount: number;
    ManagedTechCount: number;
    NonManagedTechCount: number;
    ManagedInstallerCount: number;
    PhoneCount: number;
    TollFreePhoneCount: number;
    CycleLength: number;
    IsOnboarding: boolean;
    SignupDate: Date;
    FirstBillableDate?: Date | undefined;
    LastBillingDate?: Date | undefined;
    NextBillingDate?: Date | undefined;
    Plan?: string | undefined;
}

export interface TransactionModel {
    Date: Date;
    Description?: string | undefined;
    Amount: number;
    Balance: number;
    Type?: string | undefined;
}

export enum AccountingTransactionType {
    AllTransactions = 0,
    UserFees = 1,
    ProratedUserFees = 2,
    SubscriptionFees = 3,
    Compensations = 4,
    LocalNumbers = 8,
    LocalMinutes = 16,
    TollFreeNumbers = 32,
    TollFreeMinutes = 64,
    Sms = 128,
    Adjustments = 256,
    Charges = 512,
    Refunds = 1024,
    Credits = 2048,
    Unknown = -1,
}

export interface BaseBillingRecordResultOfInvoiceRecord {
    Items?: InvoiceRecord[] | undefined;
    HasPrevious: boolean;
    HasNext: boolean;
}

export interface InvoiceRecordResult extends BaseBillingRecordResultOfInvoiceRecord {
}

export interface InvoiceRecord {
    Id?: string | undefined;
    Amount: number;
    Tax: number;
    Total: number;
    Paid: number;
    Date: Date;
    Description?: string | undefined;
    IsExported: boolean;
    IsFinished: boolean;
    Type: BillingInvoiceType;
    IsCreditMemo: boolean;
    CompanyAddress?: string | undefined;
    CompanyName?: string | undefined;
    GST_HSTRegistrationNumber?: string | undefined;
    QSTRegistrationNmber?: string | undefined;
    Countries?: string | undefined;
    CcSurchargePercentage?: number | undefined;
    CcSurchargeFee?: number | undefined;
    TypeName?: string | undefined;
}

export enum BillingInvoiceType {
    Sales = 0,
    CreditMemo = 1,
}

export interface InvoiceDetails extends InvoiceRecord {
    PreviousInvoiceId?: string;
    HasPrevious: boolean;
    NextInvoiceId?: string;
    HasNext: boolean;
    Items?: InvoiceSkuItem[];
    Splits?: PaymentSplitItem[];
    Taxes?: InvoiceTaxItem[];
}

export interface InvoiceSkuItem {
    Sku?: BillingSku | undefined;
    Name?: string | undefined;
    Description?: string | undefined;
    ItemPrice: number;
    Quantity: number;
    Total: number;
}

export enum BillingSku {
    EnterprisePlusOfficeUser = 1,
    TitanPlusOfficeUser = 2,
    TeamPlusOfficeUser = 4,
    PaperlessMobileUser = 8,
    SuperstarMobileUser = 32,
    DwyerOfficeUser = 64,
    DwyerMobileUser = 128,
    TitanOfficeUser = 256,
    TitanMobileUser = 512,
    EnterprisePlusOfficeUserProRated = 1025,
    TitanPlusOfficeUserProRated = 1026,
    PaperlessMobileUserProRated = 1032,
    SuperstarMobileUserProRated = 1056,
    DwyerOfficeUserProRated = 1088,
    DwyerMobileUserProRated = 1152,
    ServiceTitanPhonesBasicSeat = 1270,
    ServiceTitanPhonesAdvancedSeat = 1271,
    ServiceTitanRoomPhone = 1272,
    ServiceTitanFaxLine = 1273,
    STMarketingProTier1 = 1274,
    STMarketingProTier2 = 1275,
    STMarketingProTier3 = 1276,
    STMarketingProTier4 = 1277,
    STMarketingProTier5 = 1278,
    STMarketingProTier6 = 1279,
    TitanOfficeUserProRated = 1280,
    ServiceTitanPhonesTechnicianSeat = 1281,
    PhonesProHardware = 1282,
    MarketingProDirectMail = 1283,
    ReputationManagement = 1284,
    MembershipRenewalProtectionServiceFee = 1285,
    MembershipRenewalProtectionUpdatedCardsFee = 1286,
    ProfitstarsServiceFee = 1287,
    ProfitstarsACHTransactionFee = 1288,
    ProfitstarsACHReturnFee = 1289,
    ProfitstarsUnauthorizedACHReturnFee = 1290,
    ProfitstarsMobileCheckCaptureAdjustmentFee = 1291,
    ProfitstarsMobileCheckCaptureReturnFee = 1292,
    ProfitstarsMobileCheckCaptureTransactionFee = 1293,
    ProfitstarsACHAuthorizationReviewRequest = 1294,
    MarketingProContacts = 1295,
    ProfitstarsJackHenryProcessingFee = 1296,
    SmartDispatch = 1297,
    PayrollPro = 1298,
    IBSNagsLicenseFeePerMonth = 1299,
    IBSNagsSearch = 1300,
    IBSGlassCheck = 1301,
    IBSGlaxis = 1302,
    IBSSafeliteEdi = 1303,
    IBSLynxEdi = 1304,
    IBSRightGlass = 1305,
    IBSHarmonEdi = 1306,
    IBSGerberEdi = 1307,
    IBSTeleGlassEdi = 1308,
    ReputationManagementAdditionalLocations = 1309,
    IBSVinMatch = 1310,
    IBSVinLookup = 1311,
    IBSNagsLicenseFeePerYear = 1312,
    IBSQuestEdi = 1313,
    IBSGlassMatch = 1314,
    IBSGlassMatchHelp = 1315,
    VerizonOutboundLocalA2PSMSCarrierSurcharge = 1316,
    VerizonOutboundLocalA2PMMSCarrierSurcharge = 1317,
    VerizonOutboundTollFreeSMSCarrierSurcharge = 1318,
    VerizonOutboundTollFreeMMSCarrierSurcharge = 1319,
    USCellularOutboundLocalA2PSMSCarrierSurcharge = 1320,
    USCellularOutboundLocalA2PMMSCarrierSurcharge = 1321,
    ATnTOutboundLocalA2PSMSCarrierSurcharge = 1322,
    ATnTOutboundLocalA2PMMSCarrierSurcharge = 1323,
    ATnTOutboundTollFreeSMSCarrierSurcharge = 1324,
    ATnTOutboundTollFreeMMSCarrierSurcharge = 1325,
    TMobileInboundLocalA2PSMSCarrierSurcharge = 1326,
    TMobileInboundLocalA2PMMSCarrierSurcharge = 1327,
    TMobileInboundTollFreeSMSCarrierSurcharge = 1328,
    TMobileInboundTollFreeMMSCarrierSurcharge = 1329,
    TMobileOutboundLocalA2PSMSCarrierSurcharge = 1330,
    TMobileOutboundLocalA2PMMSCarrierSurcharge = 1331,
    TMobileOutboundTollFreeSMSCarrierSurcharge = 1332,
    TMobileOutboundTollFreeMMSCarrierSurcharge = 1333,
    TMobileCampaignProvisioningFee = 1334,
    TCROneTimeBrandRegistrationFee = 1335,
    TCRATnTMonthlyCampaignFee = 1336,
    ManagedInstaller = 1337,
    ProjectTracking = 1338,
    GlassDoctorLocationServiceFee = 1339,
    ManagedInstallerProRated = 1340,
    FleetProTrack = 1341,
    FleetProView = 1342,
    FleetProSmartView = 1343,
    FleetProHardware = 1344,
    FleetProShipping = 1345,
    MarketingProDirectMail4x6 = 1346,
    MarketingProDirectMail6x9 = 1347,
    MarketingProDirectMailPassthrough = 1348,
    ServiceTitanRoofing = 1349,
    FleetProLongLifeAssetTracker = 1350,
    FleetProRechargeableAssetTracker = 1351,
    FleetProLongLifeAssetTrackerHardware = 1352,
    FleetProRechargeableAssetTrackerHardware = 1353,
    CreditCardSurchargeFee = 1354,
    MarketingProSms = 1355,
    SecondChanceLeads = 1356,
    ContactCenterProHub = 1357,
    ContactCenterProAdvancedPhone = 1358,
    ContactCenterProStandardPhone = 1359,
    SalesPro = 1360,
    ContactCenterProVirtualAgents = 1361,
    SmartDispatchProRated = 1362,
    TitanMobileUserProRated = 1536,
    Sms = 2048,
    Call = 4096,
    TollFreeCall = 8192,
    Phone = 16384,
    TollFreePhone = 32768,
    DispatchBiosApp = 65536,
    GpsApp = 131072,
    RegistrationFee = 262144,
    BalanceAdjustment = 524288,
    Discount = 1048576,
    ManagedTechUser = 2097152,
    ManagedTechUserProRated = 2098176,
    IpsEnterpriseEncryptedMobileReader = 4194304,
    OvernightShipping = 8388608,
    DiscoveryGoLiveTravelFees = 16777216,
    YelpBooking = 33554432,
    PowerUserTraining = 67108864,
    ProfessionalServicesPerSow = 134217728,
    PricebookPackage = 268435456,
    PricebookPackageProRated = 268436480,
}

export interface PaymentSplitItem {
    AppliedAmount: number;
    IsInvoice: boolean;
    IsPayment: boolean;
    Invoice?: InvoiceRecord | undefined;
    Payment?: PaymentRecord | undefined;
    Id?: string | undefined;
    Amount: number;
    Description?: string | undefined;
    TypeName?: string | undefined;
}

export interface PaymentRecord {
    Id?: string | undefined;
    Amount: number;
    Applied: number;
    Date: Date;
    Description?: string | undefined;
    Type: BillingPaymentType;
    BalanceType: BillingBalanceType;
    IsRefund: boolean;
    TypeName?: string | undefined;
    BalanceTypeName?: string | undefined;
}

export enum BillingPaymentType {
    Card = 0,
    Refund = 1,
    Check = 2,
    ACH = 3,
}

export enum BillingBalanceType {
    Service = 0,
    Phone = 1,
    GettingStarted = 2,
    Other = 3,
}

export interface InvoiceTaxItem {
    Level?: string | undefined;
    Category?: string | undefined;
    TaxName?: string | undefined;
    TaxableAmount: number;
    TaxRate: number;
    Tax: number;
}

export interface BaseBillingRecordResultOfPaymentRecord {
    Items?: PaymentRecord[] | undefined;
    HasPrevious: boolean;
    HasNext: boolean;
}

export interface PaymentRecordResult extends BaseBillingRecordResultOfPaymentRecord {
}

export interface PaymentDetails extends PaymentRecord {
    PreviousPaymentId?: string;
    HasPrevious: boolean;
    NextPaymentId?: string;
    HasNext: boolean;
    Refunded: number;
    Splits?: PaymentSplitItem[];
    Refunds?: PaymentRecord[];
}

export interface TransactionModelResult {
    Transactions?: TransactionModel[] | undefined;
    SummaryRows?: string[] | undefined;
}

export interface CreditCardInfo {
    Name?: string | undefined;
    Number?: string | undefined;
    Cvc?: string | undefined;
    ExpMonth?: string | undefined;
    ExpYear?: string | undefined;
    IssuerName: CreditCardIssuer;
    Token?: string | undefined;
    BillingZip?: string | undefined;
    Primary: boolean;
    SalesForceCreditCard: boolean;
    StripeCustomerId?: string | undefined;
    Funding?: string | undefined;
}

export interface BillingCardInfo extends CreditCardInfo {
    PgRequestId?: string;
}

export enum CreditCardIssuer {
    UnknownType = 0,
    AmericanExpress = 3,
    Visa = 4,
    Mastercard = 5,
    Discover = 6,
    Sears = 7,
}

export interface PlaidBankAccountInfo {
    PublicToken?: string | undefined;
    PlaidAccountId?: string | undefined;
    InstitutionId?: string | undefined;
    VerificationStatus?: PlaidBankAccountVerificationStatuses | undefined;
}

export enum PlaidBankAccountVerificationStatuses {
    ManuallyVerified = 0,
    PendingAutomaticVerification = 1,
    PendingManualVerification = 2,
    AutomaticallyVerified = 3,
    VerificationExpired = 4,
}
